import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useGetPermissionsQuery } from "src/shared/api/rbac/rbac";
import { TablePage } from "src/shared/components/Table";
import { companiesTabsOptions } from "src/shared/constants/companiesTabs.constants";
import { useFinalReportsFilters } from "src/shared/hooks/finalReport/useGetFinalReportsFilters";
import { useGetFinalReportsListQuery } from "./api/api";
import { useGetTableColumns } from "./hooks/useGetTableColumns";
import { IFinalReportItem } from "./model/types";
import { TableHeader } from "./ui/TableHeader";

export function FinalReport() {
  const [partnerName, setPartnerName] = useState("");
  const {
    query,
    filters,
    onPaginationModelChange,
    onSearch,
    onResetFilter,
    onFilter,
    activeTab,
    setActiveTab,
  } = useFinalReportsFilters({
    partnerName,
  });

  const { data, isFetching } = useGetFinalReportsListQuery(query);
  const { columns, noteModal, deleteNoteConfirmModal } = useGetTableColumns();
  const { data: permissionData } = useGetPermissionsQuery(undefined);
  const allowedAgencies = permissionData?.data?.allowed_agencies;

  useEffect(() => {
    if (query.partner_id && data?.data.length) {
      setPartnerName(data.data[0].partner.name);
    }
  }, [data?.data, partnerName, query.partner_id]);

  return (
    <Box sx={{ height: "100%" }}>
      {noteModal}
      {deleteNoteConfirmModal}
      <TablePage<IFinalReportItem>
        localeText={{ noRowsLabel: "Нет данных за выбранный период" }}
        handleTabsChange={setActiveTab}
        tabsValue={activeTab}
        tabsOptions={companiesTabsOptions}
        loading={isFetching}
        disableTablePageHeader={isFetching}
        disableColumnSelector
        allowedAgencies={allowedAgencies}
        title={<TableHeader />}
        tableSearchModel={{
          value: query.search || "",
          onSearch,
        }}
        tableFilterModel={{
          onReset: () => {
            onResetFilter(["partner_id", "agency", "report_month"]);
          },
          onFilter,
          filters: filters,
        }}
        rowCount={data?.meta.total || 0}
        paginationMode="server"
        columns={columns}
        paginationModel={{
          page: query.page ? Number(query.page) - 1 : 0,
          pageSize: query.per_page ? Number(query.per_page) : 50,
        }}
        rows={data?.data}
        pageSizeOptions={[25, 50, 100]}
        onPaginationModelChange={onPaginationModelChange}
        disableRowSelectionOnClick
        getRowId={(row) => row.id}
      />
    </Box>
  );
}
